import { takeEvery } from 'redux-saga/effects';
import * as actionTypes from '../redux/actionTypes';
import { submitODSaga } from '../sagas/submitODSaga';
import { confirmODSaga } from '../sagas/confirmODSaga';
import { initODSaga } from '../sagas/initODSaga';

export function* transportDestructionSaga() {
  yield takeEvery(actionTypes.GETDRAFT, initODSaga);
  yield takeEvery(actionTypes.SUBMIT, submitODSaga);
  yield takeEvery(actionTypes.CONFIRM, confirmODSaga);
}
